import { isSupportTab } from './tokenStore.js';

/**
 * 「마스터·대표 아이디인가」 화면 비교(dentium·plasmapp·admin_dentiumchina·zeiss 등)에 쓸 아이디.
 * 11-01 사용자 결정: 지원 탭 = 그 회사 최상위 관리자와 같은 메뉴·버튼·수정 기능.
 * 지원 탭이면 서버가 판정에 쓴 아이디 — GET /privileges/<지원 서브 계정> 이 돌려준 메뉴 문서의 username
 * (inapi decisionUsername: 마스터 dentium·point, 없으면 대표). 아직 못 읽었거나 지원 탭이 아니면 넘긴 값 그대로.
 * 화면 비교에만 쓴다 — 작성자·「누가 했나」(contractCreator 등)는 지원 서브 계정 그대로.
 * privileges = store.state.privileges(부르는 쪽이 넘김 — 계산 속성 안에서 부르면 메뉴를 읽은 뒤 다시 계산됨)
 */
export function masterCheckUsername(username, privileges) {
  return (isSupportTab() && privileges?.username) || username;
}
